import { render, staticRenderFns } from "./DashboardSideDataWidget.vue?vue&type=template&id=773972f8&scoped=true&"
import script from "./DashboardSideDataWidget.vue?vue&type=script&lang=js&"
export * from "./DashboardSideDataWidget.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSideDataWidget.vue?vue&type=style&index=0&id=773972f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773972f8",
  null
  
)

export default component.exports